/**
 * Invoice Value Not String
 */

export default ['type', 'invoiceType', 'invoiceDelivery', 'status', 'total', 'due', 'invoiceStatus', 'fetchFinalizedInvoice'];
